/** 与后端 {@code ProjectLifecycleStatuses} 对齐的项目生命周期。 */

export const PROJECT_VOID_READONLY_HINT = '项目已作废，仅可查看和下载，不可修改';
export const PROJECT_VOID_CONFIRM_TOKEN = '作废';

export function normalizeProjectLifecycleStatus(status?: string | null): string {
  const s = String(status || '').trim().toUpperCase();
  if (s === 'ACTIVE' || s === 'PLANNED' || s === 'IN_PROGRESS') return 'NORMAL';
  if (s === 'COMPLETED' || s === 'CLOSED') return 'CLOSED';
  if (s === 'TERMINATED') return 'VOID';
  if (s === 'NORMAL' || s === 'DELAYED' || s === 'SUSPENDED' || s === 'VOID') return s;
  return 'NORMAL';
}

export function isProjectVoided(status?: string | null): boolean {
  return normalizeProjectLifecycleStatus(status) === 'VOID';
}

export function projectLifecycleLabel(status?: string | null): string {
  switch (normalizeProjectLifecycleStatus(status)) {
    case 'DELAYED':
      return '延期';
    case 'SUSPENDED':
      return '挂起';
    case 'CLOSED':
      return '已完成';
    case 'VOID':
      return '作废';
    default:
      return '正常';
  }
}
